<template>
	<iframe 
		ref="iframeDom"
		:srcdoc="html"
		frameborder="0"
		@load="onIframeLoad"
	></iframe>
</template>

<script>
	export default {
		name: 'cl-rich-text',
		props: {
			html: {
				type: String,
				default: '',
			},
		},
		data() {
			return {
				description: '富文本渲染',
			}
		},

		methods: {
			onIframeLoad() {
				const dom = this.$refs.iframeDom;
				const doc = dom.contentWindow.document;
				// 设置body换行
				Object.assign(doc.body.style, {
					wordBreak: 'break-all',
					margin: '0'
				});
				// body换行后，获取iframe高度。
				const bodyHeight = doc.body.scrollHeight;
				const documentHeight = doc.documentElement.scrollHeight;
				const maxHeight = Math.max(bodyHeight, documentHeight);
				// 设置iframe的宽高
				this.$refs.iframeDom.height = maxHeight + 'px';
				this.$refs.iframeDom.width = getComputedStyle(this.$refs.iframeDom.parentNode).width;
			}
		}
	}
</script>